import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Atanu Biswas </span>
            from <span className="purple"> Kolkata, India.</span>
            <br />
            I am currently employed as a DevSecOps at <span className="purple">HumanManaged</span>.
            <br />
            I have completed my B.Tech in <span className="purple">Mechanical Engineering</span> From Narula Institure of Technology
            <br />
            <br />
            Apart from DevSecOps, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Mobile Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Atanu</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
